import { defineModel } from 'foca';

const initialState: Record<
  string,
  {
    name: string;
  }
> = {};

export const suiNSNamesModel = defineModel('sui-ns-names', {
  initialState,
  reducers: {
    updateNs(state, address: string, nsName: string) {
      state[address] = {
        name: nsName,
      };
    },
  },
});
